module.exports = __webpack_public_path__ + "footchatu2.png?b67b27bddd0c2a33aa30058f5686d2e1";